import React, { Component } from "react";
import { Select } from "antd";
import styles from "./index.less";

interface Props {
  userType: any;
  enterpriseType: any;
  customField: any;
  phoneValue: any;
  caseType:any;
  handleSelect: (id: any, selectValue: any) => void;
}

interface State {}

class Confirmation extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      userType,
      enterpriseType,
      customField,
      handleSelect,
      caseType
    } = this.props;
    return (
      <div className={styles.confirmation}>
        <div className={styles.title}>您的验证信息</div>
        <div className={styles.content}>
          {/* <span>
            您的账号：
            <i>{phoneValue.replace(phoneValue.substring(3, 7), "****")}</i>
          </span> */}
          {userType ? (
            <span>
              用户类型：<i>{userType.name}</i>
            </span>
          ) : null}
          {enterpriseType ? (
            <span>
              企业类型：<i>{enterpriseType.name}</i>
            </span>
          ) : null}
          {caseType?(<span>
              申诉类型：<i>{caseType}</i>
            </span>):null}
        </div>
        {customField ? (
          <div className={styles.select}>
            <Select
              style={{ width: "30%" }}
              defaultValue={customField.showName}
              onSelect={handleSelect}
            >
              {customField.selectList.map((item: any, index: number) => {
                return (
                  <Select.Option value={item.id} key={index}>
                    {item.name}
                  </Select.Option>
                );
              })}
            </Select>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Confirmation;
